import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

const StoreFaq = forwardRef(({ storeName }, ref) => (
  <div ref={ref}>
    <Heading as="h2" size="size6">
      Como conseguir cupom de desconto {storeName}?
    </Heading>
    <Text
      className="mt-2 text-sm text-neutral-low-300 dark:text-neutral-high-300"
      size="size3"
    >
      É só ficar de olho nas novidades aqui do Promobit ou adicionar os cupons{' '}
      {storeName} na sua Lista de Desejos. Nossa equipe de especialistas em
      promoções está sempre de olho para compartilhar aqui qualquer novo cupom
      que você possa aproveitar. Assim, você não perde nada e ainda economiza.
    </Text>
    <hr className="my-6 border-neutral-high-300 dark:border-neutral-low-200" />
  </div>
));

StoreFaq.displayName = 'StoreFaq';

StoreFaq.propTypes = {
  storeName: PropTypes.string.isRequired,
};

export default StoreFaq;
